import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper, useMediaQuery } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody2, TableBottom, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { adminStkInwMenu, StkInwMenu, Zones } from '../TitleList';
import { fetchStkInwData } from '../../Store/PHPSlice/StkInw';
import { selectStkInwdata } from '../Selectors/Master/OutwardSelectors';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';


const StkInwReg = () => {
    const dispatch = useDispatch();
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const isDesktop = useMediaQuery('(min-width:768px)');
    const getItems = useSelector(selectStkInwdata);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');
    const [formData, setFormData] = useState({
        fdt: '',
        tdt: '',
        barcd: '',
    });
    const [activeMenu, setActiveMenu] = useState(StkInwMenu);

    useEffect(() => {
        dispatch(fetchStkInwData());
    }, [dispatch]);


    useEffect(() => {
        if (!userdata) return;


        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(adminStkInwMenu);
            } else {
                setActiveMenu(StkInwMenu);
            }


        }
    }, []);

    if (!getItems) {
        return <h1>Loading...</h1>;
    }

    // console.log(getItems)

    const compData = Array.isArray(getItems.data) ? getItems.data.map((item, index) => (
        {
            srNo: item.ID,
            dt: item.dt,
            stkMemo: item.stkMemo,
            inwType: item.inwType,
            partyId: item.partyId,
            partyNm: item.partyNm,
            firmId: item.firmId,
            firmNm: item.firmNm,
            totqty: item.totqty,
            netamt: item.netamt,
            totamt: item.totamt,
            igst: item.igst,
            cgst: item.cgst,
            sgst: item.sgst,
            sts: item.sts,
            serialNumber: index + 1
        }
    )) : [];


    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };



    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.stkMemo?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const gstamtdata = filteredData?.map(item => ({
        gstamt: parseFloat(item.igst) + parseFloat(item.cgst) + parseFloat(item.sgst)
    }));
    const totgstamt = gstamtdata?.reduce((acc, sum) => acc + parseFloat(sum.gstamt), 0);
    const totqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totqty), 0);
    const totamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totamt), 0);
    const totnetamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.netamt), 0);


    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };
    // console.log(displayedData);
    const fields = [
        { label: 'From Date', name: 'fdt', type: 'date' },
        { label: 'To Date', name: 'tdt', type: 'date' },
        // { label: 'Barcode', name: 'freight_ch' },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleSearch = (e) => {
        e.preventDefault();

        if (formData.fdt === '') {
            alert('Please Select From Date.');
            return; // Stop form submission
        }
        if (formData.tdt === '') {
            alert('Please Select To Date.');
            return; // Stop form submission
        }

        dispatch(fetchStkInwData({ fdt: formData.fdt, tdt: formData.tdt }));
    };
    return (
        <>
            <Titlebar data={activeMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Stock Inward Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>
                                {fields.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleInputChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button>

                                </Grid>
                            </Grid>

                            <Grid item xs={12} textAlign="center" style={{ marginTop: '4%' }}>
                            </Grid>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={[
                                            { id: 'srNo', label: 'Sr.No' },
                                            { id: 'dt', label: 'Date' },
                                            { id: 'inwType', label: 'Order Type' },
                                            { id: 'stkMemo', label: 'Inward No.' },
                                            { id: 'firmNm', label: 'Firm' },
                                            { id: 'partyNm', label: 'Party' },
                                            { id: 'totqty', label: 'Total Qty.' },
                                            { id: 'totamt', label: 'Total Amt.' },
                                            { id: '', label: 'GST Amt.' },
                                            { id: 'netamt', label: 'Net Amt' },
                                            { id: 'view', label: 'View' },
                                            { id: 'edit', label: 'Edit' },
                                            { id: 'delete', label: 'Delete' }
                                        ]}

                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData && displayedData.length > 0 ? (
                                            <>
                                                {displayedData?.map((row) => (
                                                    <TableBody2
                                                        key={row.srNo}
                                                        id={row.srNo}
                                                        dt={row.dt}
                                                        stkMemo={row.stkMemo}
                                                        inwType={row.inwType}
                                                        partyId={row.partyId}
                                                        partyNm={row.partyNm}
                                                        firmId={row.firmId}
                                                        firmNm={row.firmNm}
                                                        totqty={row.totqty}
                                                        netamt={row.netamt}
                                                        totamt={row.totamt}
                                                        igst={row.igst}
                                                        cgst={row.cgst}
                                                        sgst={row.sgst}
                                                        sts={row.sts}
                                                        serialNumber={row.serialNumber}
                                                        selected={selected.indexOf(row.name) !== -1}
                                                        handleClick={(event) => handleClick(event, row.name)}
                                                    />
                                                ))}
                                                <TableBottom
                                                    totqty={totqty}
                                                    totamt={totamt}
                                                    totgstamt={totgstamt}
                                                    totnetamt={totnetamt}
                                                />
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={12} style={{ textAlign: "center", padding: "10px" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default StkInwReg;
